function printdebug(value){
    const debug=true;
    if(debug){

        console.log(value);
    }
}
export default printdebug;
